import type {
  AwsRequestQuery,
  ChatApi,
  ChatItemMessage,
  FileUrlResponse,
} from "@/Modules/Chat/Models/Api/Chat";
import type { AwsUploadRequestApiResponse } from "@/Modules/Chat/Models/Api/Chat";

import { get2, patch2, remove2 } from "./utils/FunctionalTherapyApi";

export const getFileSrc = (url: string): Promise<FileUrlResponse> => {
  return get2<void, FileUrlResponse>(`${url}/src-url`);
};

export const awsUploadFileRequest = (awsFileQuery: AwsRequestQuery): Promise<AwsUploadRequestApiResponse> => {
  return get2<void, AwsUploadRequestApiResponse>(
    `/chat/upload?content_type=${awsFileQuery.content_type}&file_name=${awsFileQuery.file_name}&upload_type=chat`,
    undefined,
    {},
    { raw: true }
  );
};

export const getChats = (): Promise<ChatApi[]> => {
  return get2<void, ChatApi[]>(`/v1.0/chats`);
};

export const getChat = (chatId: string): Promise<ChatApi> => {
  return get2<void, ChatApi>(`/v1.0/chats/${chatId}`);
};

export const getChatEvents = (
  chatId: string,
  page: number,
  page_size: number
): Promise<ChatItemMessage[]> => {
  return get2<void, ChatItemMessage[]>(`/v1.0/chats/${chatId}/events?page_size=${page_size}&page=${page}`);
};

export const acceptChangeSessionDuration = (chatId: string): Promise<ChatApi> => {
  return patch2<void, ChatApi>(`/v1.0/chats/${chatId}/session_duration`, undefined);
};

export const rejectChangeSessionDuration = (chatId: string): Promise<ChatApi> => {
  return remove2<void, ChatApi>(`/v1.0/chats/${chatId}/session_duration`, undefined);
};
